import React, { useEffect, useState } from "react";
import "../../Pages/Layouts/artifacts/css/spinner.css";

export default function Spinner({ text, visible = true }) {
  const [shouldRender, setShouldRender] = useState(false);
  const [hiding, setHiding] = useState(false);

  useEffect(() => {
    if (visible) {
      const showTimer = setTimeout(() => setShouldRender(true), 150);
      return () => clearTimeout(showTimer);
    }
  }, [visible]);

  useEffect(() => {
    if (!visible && shouldRender) {
      setHiding(true);
      const hideTimer = setTimeout(() => {
        setShouldRender(false);
        setHiding(false);
      }, 260);
      return () => clearTimeout(hideTimer);
    }
  }, [visible, shouldRender]);

  if (!shouldRender) return null;

  return (
    <div className={`spin-container ${hiding ? "spin-hiding" : "spin-visible"}`}>
      <div className="spin-bar-track">
        <div className="spin-bar" />
      </div>
      <div className="spin-center">
        <div className="spin-dots">
          <span className="spin-dot" />
          <span className="spin-dot" />
          <span className="spin-dot" />
        </div>
        {text && <span className="spin-label">{text}</span>}
      </div>
    </div>
  );
}
